module.exports = __webpack_public_path__ + "347e9c3295965a67fc1581caa6c91b66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_100.jpg
// module id = 1693
// module chunks = 5